const routes = [
  {
    path: '/letter-handler',
    name: 'letter-handler',
    component: () => import('./views/letterHandler.vue'),
    meta: {
      title: 'Мониторинг',
      role: ['admin'],
    },
  },
  {
    path: '/users-errors',
    name: 'users-errors',
    component: () => import('./views/usersErrors.vue'),
    meta: {
      title: 'Мониторинг',
      role: ['admin'],
    },
  },
  {
    path: '/users-errors/:id',
    name: 'error-details',
    component: () => import('./views/errorsDetails.vue'),
    meta: {
      title: 'Ошибки пользователя',
      role: ['admin'],
    },
  },
];

export default routes;
